module.exports = __webpack_public_path__ + "static/img/son1_active.e91f0405.png";